var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "select_opt_area",
      attrs: { id: "frdg_area_" + _vm.cntrSeq },
    },
    [
      _c("h3", { staticClass: "content_title mt10" }, [
        _vm._v(_vm._s(_vm.oogCgoTypCd === "03" ? "In Gauge" : "Out of Gauge")),
      ]),
      _c("booking-table-oog", {
        key: _vm.oogCgoTypCd,
        ref: "oog",
        attrs: {
          index: _vm.index,
          "parent-info": _vm.parentInfo,
          "cgo-typ-cd": _vm.oogCgoTypCd,
          "cntr-typ-cd": _vm.parentInfo.cntrTypCd,
          "kmd-vsl-check": _vm.kmdVslCheck,
          "empty-flag": _vm.emptyFlag,
          lang: _vm.lang,
          "save-flag": _vm.saveFlag,
          "grs-wt-ton": _vm.grsWtTon,
          "application-info-yn": "N",
        },
        on: { "upload-attachments": _vm.openDgAttachments },
      }),
      _c("h3", { staticClass: "content_title mt10" }, [
        _vm._v(_vm._s(_vm.lang === "KOR" ? "위험물" : "DG")),
      ]),
      _c("booking-table-dg", {
        ref: "dg",
        attrs: {
          index: _vm.index,
          "parent-info": _vm.parentInfo,
          "parent-dg-list": _vm.dgList,
          "cas-no-port-yn": _vm.casNoPortYn,
          "tel-ctr-no": _vm.telCtrNo,
          "disabled-yn": _vm.disabledYn,
          "unno-disabled-yn": _vm.unnoDisabledYn,
          lang: _vm.lang,
          "save-flag": _vm.saveFlag,
          "bkg-sts-cd": _vm.bkgStsCd,
          "bkg-vsl-doc-yn": _vm.bkgVslDocYn,
          "status-class": _vm.statusClass,
        },
        on: {
          vanningChk: function ($event) {
            return _vm.$emit("vanningChk")
          },
        },
      }),
      _c("booking-dg-notice", { attrs: { lang: _vm.lang } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }